export const ADVANCED_SEARCH = "ADVANCED_SEARCH";
export const ADVANCED_SEARCH_SUCCESS = "ADVANCED_SEARCH_SUCCESS";
export const ADVANCED_SEARCH_FAILURE = "ADVANCED_SEARCH_FAILURE";
export const ADVANCED_SEARCH_RESET = "ADVANCED_SEARCH_RESET";
